import { useState } from 'react'
import { ChevronRight } from 'lucide-react'

function formatDate(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric'
  })
}

export default function RecentlyRejectedSection({ rows }) {
  const [open, setOpen] = useState(false)

  if (rows.length === 0) return null

  return (
    <section className="mb-6">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 px-1 py-1 -mx-1 rounded hover:bg-muted/40 text-xs uppercase tracking-wide text-muted-foreground"
      >
        <ChevronRight
          className={`size-3.5 transition-transform ${open ? 'rotate-90' : ''}`}
        />
        <span className="font-semibold">Recently rejected</span>
        <span className="inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full bg-muted text-foreground">
          {rows.length}
        </span>
        <span className="text-[10px] normal-case font-normal opacity-70">last 14 days</span>
      </button>

      {open && (
        <div className="mt-2 rounded-lg border border-border bg-card overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-xs uppercase tracking-wide text-muted-foreground">
                <th className="text-left font-medium px-4 py-2">Business</th>
                <th className="text-left font-medium px-4 py-2">Contact</th>
                <th className="text-left font-medium px-4 py-2">Rejected</th>
                <th className="text-left font-medium px-4 py-2">Reason</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} className="border-b border-border last:border-b-0">
                  <td className="px-4 py-2.5 font-medium">{row.business_name}</td>
                  <td className="px-4 py-2.5">
                    <div className="text-foreground">{row.contact_name}</div>
                    <div className="text-xs text-muted-foreground">{row.email}</div>
                  </td>
                  <td className="px-4 py-2.5 text-muted-foreground whitespace-nowrap">
                    {formatDate(row.reviewed_at)}
                  </td>
                  <td className="px-4 py-2.5 text-muted-foreground">
                    {row.rejection_reason ? (
                      <span title={row.rejection_reason} className="line-clamp-1">
                        {row.rejection_reason}
                      </span>
                    ) : (
                      <span className="italic opacity-60">No reason recorded</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
